import { render, staticRenderFns } from "./registerClient.vue?vue&type=template&id=2ab6dc43&"
import script from "./registerClient.vue?vue&type=script&lang=js&"
export * from "./registerClient.vue?vue&type=script&lang=js&"
import style0 from "./registerClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports